/**
 * Defines the available gallery layouts for read-only rendering.
 */
export enum GalleryViewMode {
    /**
     * Arranges visible items in a square-first layout.
     */
    SQUARE,
    /**
     * Arranges visible items in the gallery grid layout.
     */
    GRID,
}
